import { fireSearchGAEvent, fireSearchCategoryPushEvent } from '@global/gtm/base';

class SearchGTMEvent {
  static getKeyword(isHotSearch, keyword) {
    const category = {
      itemCategory: isHotSearch ? '關鍵字熱搜' : '關鍵字搜尋',
      itemCategory2: keyword,
      url: window.location.pathname,
    };

    return category;
  }
}

export default function fireSearchEvent(payload) {
  window.dataLayer = window.dataLayer || [];

  window.ItemCategories = payload.isHotSearch
    ? ['搜尋結果頁', '熱字', payload.keyword]
    : ['搜尋結果頁', '關鍵字', payload.keyword];

  const category = SearchGTMEvent.getKeyword(payload.isHotSearch, payload.keyword);

  fireSearchCategoryPushEvent(category);

  if (payload.isHotSearch) {
    fireSearchGAEvent({
      searchType: '關鍵字熱字',
      searchContent: payload.keyword,
    });
  } else {
    fireSearchGAEvent({
      searchType: '關鍵字搜尋',
      searchContent: payload.keyword,
    });
  }
}
